export interface BiTrackParams {
    event_type: string; // 功能名
    source_type?: string; // 来源
    session_id?: string;
    other_param?: string; // 其他参数，普通string
    event_detail_str?: string; // 事件详情。jsonString传递的数据量大推荐使用这个
    module_type: string; // 模块类型
}

export interface BiTrackEventType {
    sourceType: string;
    session_id?: string;
    otherParam?: string;
    eventDetailStr?: Record<string, unknown> | string;
}

export enum EurekaTrackEventType {
    SHARE_INFO = 'SS Share Info',
    AGENT_VIEW = 'SS Agent View',
    QUICK_RESEARCH = 'SS Quick Research',
    HOME = 'SS Eureka Home Page',
    WORK_PROJECT = 'SS Work Project',
    TRIZ = 'SS TRIZ Mind',
    COMPANY_SCOUT = 'SS COMPANY SCOUT',
    PLG_QA = 'SS PLG QA',
    LS_COMMON = 'FF LS Common'
}
